import {Box, HStack, Text} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import i18n from '../../../i18n/i18n';

export function ChartLegend(props: TestIdProps) {
  return (
    <HStack justify={['center', 'center', 'flex-end', 'flex-end']} spacing={6}>
      <HStack align="center" spacing={2}>
        <Box
          backgroundColor="palettes.neutral.60.100"
          height={4}
          width={4}
          borderRadius="circular"
          data-testid={suffixTestId('legendSold', props)}
        />
        <Text size="small" data-testid={suffixTestId('legendSold', props)}>
          {i18n.t('entity.overviewStatisticsMileageChart.labels.legendSold')}
        </Text>
      </HStack>
      <HStack align="center" spacing={2}>
        <Box
          backgroundColor="severity.warning"
          height={4}
          width={4}
          borderRadius="circular"
          data-testid={suffixTestId('legendStock', props)}
        />
        <Text size="small" data-testid={suffixTestId('legendStock', props)}>
          {i18n.t('entity.overviewStatisticsMileageChart.labels.legendStock')}
        </Text>
      </HStack>
    </HStack>
  );
}
